import AttributeExpression from './AttributeExpression';
import { renderer } from '../Renderer';
import { isType } from '../../js';

class CSSExpression extends AttributeExpression {

	value:string;

	constructor( node:Element, template:string ) {
		super( node, 'class', template );
	}

	getValue( data ) {
		return this.template.replace( renderer.pass.regex, ( match ) => {
			let value = renderer.render( match, data );

			// string value simple return
			if( isType( value, 'String' ) ) return value;

			// object syntax for classes; filter false values and return keys as string
			if( isType( value, 'Object' ) ) return Object.keys( value ).filter( key => value[key] ).join( ' ' );

			// for anything else return empty string
			return '';
		});
	}

	/**
	 * Cache value for css merging
	 */
	writeValue( value:string ) {
		super.writeValue( value );
		this.value = value;
	}
}

export default CSSExpression;
